import { render, staticRenderFns } from "./ReceiptNumber.vue?vue&type=template&id=26c107ba&"
import script from "./ReceiptNumber.vue?vue&type=script&lang=js&"
export * from "./ReceiptNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports